import { Launch } from '@mui/icons-material';
import { type FeaturedThreadResPagedData } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { Pagination } from '@on3/ui-lib/components/Pagination/Pagination';
import { BoardItem } from '@public/components/MegaBoard/BoardItem';
import { useSearchParams } from 'next/navigation';

import styles from './MegaBoard.module.scss';

interface IMegaBoardProps {
  threadData: FeaturedThreadResPagedData | null;
}

export const MegaBoard = ({ threadData }: IMegaBoardProps) => {
  const query = useSearchParams();
  const page = query.get('page') || '1';

  return (
    <div className={styles.block}>
      <header className={styles.header}>
        <h1>MegaBoard</h1>
        <div className={styles.row}>
          <p>
            <strong>The Community of College Sports</strong> — Selected from
            On3&apos;s extensive fan site message boards.
          </p>
          <Link className={styles.joinBtn} href="/boards/">
            Join the Community
            <Launch />
          </Link>
        </div>
      </header>
      <section>
        <div className={styles.list}>
          {threadData?.list?.map((item, idx) => (
            <BoardItem
              isFeatured={idx === 0 && page === '1'}
              key={item.threadKey}
              {...item}
            />
          ))}
        </div>
        <Pagination data={threadData?.pagination} type="expanded" />
      </section>
    </div>
  );
};
